module.exports = __webpack_public_path__ + "static/cubes_left-9a8fbc4cb368ef1e3dacced99ee880cb.png";